// extracted by mini-css-extract-plugin
export default {"checkout_form":"Chekout_checkout_form__-b1Kz"};